(() => {
  if (window.lnxDeepReady) return;
  window.lnxDeepReady = true;
  const roots = () => [...document.querySelectorAll('[data-deep-combo]')];
  const q = (root, key) => root.querySelector('[data-deep-' + key + ']');
  const catalog = root => root.deepCatalog || (root.deepCatalog = JSON.parse(q(root, 'data').textContent));
  const input = root => document.getElementById(root.dataset.formId + '-quantity');
  function state(root) {
    const data = catalog(root), form = document.getElementById(root.dataset.formId);
    const id = root.dataset.variant || form?.elements.namedItem('id')?.value || data.initialVariant;
    const lamp = data.lamp.find(v => String(v.id) === String(id));
    const kind = q(root, 'driver').value, driver = data[kind]?.[0], frame = data.needsFrame ? data.frame[0] : null;
    const count = Number(input(root)?.value ?? 1);
    const driverCount = (data.driversPerLuminaire || 1) * (kind === 'ip68' ? Math.ceil(count / 2) : kind === 'dali' ? Math.ceil(count / (data.daliCapacity || 1)) : count);
    let error = '';
    if (!Number.isSafeInteger(count) || count < 1) error = data.text.invalid;
    else if (!lamp?.available || !driver?.available || (data.needsFrame && !frame?.available)) error = data.text.unavailable;
    if (root.dataset.pending) error = data.text.loading;
    return { data, lamp, driver, frame, count, driverCount, kind, error };
  }
  function sync(root) {
    const c = state(root);
    const money = n => new Intl.NumberFormat(c.data.locale, {style:'currency',currency:c.data.currency}).format(n/100);
    q(root, 'driver-note').textContent = c.data.text[c.kind + '_note'];
    q(root, 'warm').hidden = !/2000.*3000|1800.*2850|dim[ -]*to[ -]*warm/i.test(c.lamp?.title || '');
    const image = q(root, 'image');
    if (image.getAttribute('src') !== c.data.images[c.kind]) image.src = c.data.images[c.kind];
    image.alt = c.data.text.driver + ' · ' + c.data.text[c.kind];
    q(root, 'lamp-label').textContent = c.count + ' × ' + c.data.title + ' (' + (c.lamp?.title || '') + ')';
    q(root, 'driver-label').textContent = c.driverCount + ' × ' + c.data.text.driver + ' · ' + c.data.text[c.kind];
    if (c.data.needsFrame) q(root, 'frame-label').textContent = c.count + ' × ' + c.data.text.frame;
    (c.data.needsFrame ? ['lamp','driver','frame'] : ['lamp','driver']).forEach(k => q(root, k + '-price').textContent = c[k] && Number.isSafeInteger(c.count) && c.count > 0 ? money(c[k].price * (k === 'driver' ? c.driverCount : c.count)) : '–');
    const lampTotal = (c.lamp?.price || 0) * c.count;
    const volume = c.count >= 3 ? Math.round(lampTotal * 0.04) : 0;
    const subtotal = lampTotal - volume + (c.driver?.price || 0) * c.driverCount + (c.frame?.price || 0) * c.count;
    const order = subtotal >= 50000 ? Math.floor(subtotal * 5 / 100) : 0;
    q(root, 'volume-row').hidden = !!c.error || !volume;
    q(root, 'order-row').hidden = !!c.error || !order;
    q(root, 'volume').textContent = '− ' + money(volume);
    q(root, 'order').textContent = '− ' + money(order);
    q(root, 'total').textContent = c.error ? '–' : money(subtotal - order);
    q(root, 'error').textContent = c.error;
    q(root, 'error').hidden = !c.error;
  }
  const all = () => roots().forEach(sync);
  const schedule = () => { setTimeout(all, 0); setTimeout(all, 100); setTimeout(all, 300); };
  document.addEventListener('input', event => {
    if (event.target.name === 'quantity') schedule();
  }, true);
  document.addEventListener('change', event => {
    const root = event.target.closest('[data-deep-combo]');
    if (root) sync(root);
    else if (event.target.closest('variant-picker')) {
      roots().forEach(r => {r.dataset.pending = '1';});
      schedule();
    } else if (event.target.name === 'quantity') schedule();
  }, true);
  document.addEventListener('click', event => {
    if (event.target.closest('quantity-selector button')) schedule();
  }, true);
  document.addEventListener('variant:change', event => {
    roots().forEach(root => {
      if (event.target.getAttribute?.('id') !== root.dataset.formId) return;
      if (event.detail?.variant?.id) root.dataset.variant = String(event.detail.variant.id);
      else delete root.dataset.variant;
      delete root.dataset.pending;
    });
    schedule();
  });
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('[data-deep-combo]')) sync(event.target);
  }, true);
  document.addEventListener('shopify:section:load', all);
  document.addEventListener('submit', async event => {
    const root = roots().find(r => r.open && r.dataset.formId === event.target.getAttribute('id'));
    if (!root) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (root.dataset.adding) return;
    sync(root);
    const c = state(root);
    if (c.error) {q(root, 'error').scrollIntoView({block:'nearest'});return;}
    root.dataset.adding = '1';
    const button = event.target.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    try {
      const prefix = window.Shopify?.routes?.root || '/';
      const response = await fetch(prefix + 'cart/add.js', {
        method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({items:[{variant:c.lamp,quantity:c.count},{variant:c.driver,quantity:c.driverCount},{variant:c.frame,quantity:c.count}].filter(item => item.variant).map(item => ({id:item.variant.id,quantity:item.quantity}))})
      });
      if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new Error(payload.description || c.data.text.error);
      }
      window.location.href = prefix + 'cart';
    } catch(error) {
      q(root, 'error').textContent = error.message;
      q(root, 'error').hidden = false;
      if(button) button.disabled = false;
      delete root.dataset.adding;
    }
  }, true);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all, {once:true}); else all();
})();
